/**
 * Telling "the caller cancelled this" apart from "this failed".
 *
 * Every screen here aborts its in-flight request when its inputs change or it
 * unmounts, and an abort is the app's own doing — showing it as an error would
 * make a fast typist watch the list flash red on every keystroke.
 *
 * `fetch` rejects with a `DOMException` named `AbortError`, whose relationship
 * to `Error` has changed across browser versions, so the `name` is what is
 * checked rather than the constructor.
 */
export function isAbortError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  return (error as { name?: unknown }).name === 'AbortError';
}
